import { Button, ButtonContainer, Card, ContentSection, Layout } from '@vwfs-bronson/bronson-react';
import { t } from 'i18next';
import React, { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationSummary } from '../../../components/ApplicationSummary/ApplicationSummary';
import { WebCalc } from '../../../components/WebCalc/WebCalc';
import { journeyDataSelectors } from '../../../services/redux/features/journeyData.slice';
import { newCarConfiguratorPageSliceSelectors } from '../NewCarConfiguratorPage/newCarConfiguratorPage.slice';
import { newQuotationSliceActions, WizardPagesEnum } from '../newQuotation.slice';

export const FinancialProductPage: FunctionComponent = () => {
  const dispatch = useDispatch();
  const vehicleType = useSelector(journeyDataSelectors.vehicleType);
  const betterBePayload = useSelector(newCarConfiguratorPageSliceSelectors.configurationResult);

  return (
    <>
      <ContentSection pageWrapSize="small">
        <Card title="" className="u-mb">
          <ApplicationSummary isDefaultOpen={false} />
        </Card>
        <Card className="u-text-left" title="">
          {/* placeholder spacing so the card is taller */}
          <Layout>
            <Layout.Item>
              <WebCalc betterBePayload={betterBePayload} />
            </Layout.Item>
          </Layout>
        </Card>
      </ContentSection>

      <ContentSection pageWrapSize="small">
        <Layout center>
          <ButtonContainer center>
            <Layout.Item default="1/3">
              <Button
                type="button"
                full
                testId="button_back"
                secondary
                onClick={() => {
                  const backPage =
                    vehicleType === 'used' ? WizardPagesEnum.vehicle : WizardPagesEnum.newCarConfigurator;
                  dispatch(newQuotationSliceActions.wizardNavigateToPage(backPage));
                }}
              >
                {t('financialProductPage:navigation:cancel')}
              </Button>
            </Layout.Item>
            <Layout.Item default="1/3">
              <Button
                type="submit"
                full
                testId="button_continue"
                onClick={() => {
                  dispatch(newQuotationSliceActions.wizardNavigateToPage(WizardPagesEnum.compareQuotes));
                }}
              >
                {t('financialProductPage:navigation:continue')}
              </Button>
            </Layout.Item>
          </ButtonContainer>
        </Layout>
      </ContentSection>
    </>
  );
};
